<template>
  <div class="home" id="home1" v-if="siteDataReady">

    <!-- this is for rendering the fonts on start -->
    <div class="hiddenfonttext">{{localize(siteData.SECTIONS[0].desc)}}</div>
    <site-menu :isMenuOpen="isMenuOpen" @close-menu="isMenuOpen=false"></site-menu>
    <lang-menu :isMenuOpen="isLangOpen" @close-menu="isLangOpen=false"></lang-menu>

    <div :class="['topBar']">
      <img @click="navToStart" class="topLogo" src="/img/mguide/mguide.svg" alt="" />      
      <!-- main menu opener -->
      <div class="menuOpen" @click="openMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- lang menu opener -->
      <div class="menuLang" @click="toggleLangMenu" id="langtoggle1">
        {{getLangByRoute().toUpperCase()}}<i class="fal fa-chevron-down" ></i>
      </div>
    </div>    

    <div class="fixedHeroVideo">
        <home-hero></home-hero>
    </div>

    <main v-if="siteReady" id="mainScroller">
      <section class="siteSection transparentSection">
        &nbsp; <!--empty transparent section for the video bg-->
      </section>
      <section class="siteSection heroText">
        <home-hero-text></home-hero-text>
      </section>
      <section class="siteSection secBgGray2">
        <home-benefits></home-benefits>
      </section>
      <section class="siteSection workflow">
        <workflow></workflow>
      </section>
      <section class="siteSection surgicalkits">
        <surgicalkits></surgicalkits>
      </section>
      <section class="siteSection surgicalkits">
        <digital-restoration></digital-restoration>
        <!-- <digital-items></digital-items> -->
      </section>
      <section class="siteSection tv">
        <tutorial-videos></tutorial-videos>
      </section>
      <section class="siteSection">
        <mcenters></mcenters>
      </section>
      <section class="siteSection secBgGray3">
        <msoft></msoft>
      </section>
      <section class="siteSection footer">
        <lance-footer></lance-footer>
      </section>
    </main>
  </div>
</template>

<script>
  import LangMenu           from "@/views/com/langmenu.vue";
  import SiteMenu           from "@/views/com/menu.vue";
  import HomeHero           from "@/views/lance/LanceHero.vue";
  import HomeHeroText       from "@/views/lance/LanceHeroText.vue";
  import HomeBenefits       from "@/views/lance/Benefits.vue";
  import Workflow           from "@/views/lance/Workflow.vue";  
  import surgicalkits         from "@/views/lance/SurgicalKits.vue";  
  import DigitalRestoration   from "@/views/lance/DigitalRestoration.vue";  
  import DigitalItems         from "@/views/lance/DigitalItems.vue";  
  import ImplantRange       from "@/views/lance/LanceImplantRange.vue";
  import DrillingProtocols  from "@/views/lance/LanceDrillingProtocols.vue";
  import TechInfo           from "@/views/lance/LanceTechInfo.vue";
  import InsertionOptions   from "@/views/lance/LanceInsertionOptions.vue";
  import Packaging          from "@/views/lance/LancePackaging.vue";  
  import Coverscrews        from "@/views/lance/LanceCoverscrews.vue";  
  import Prosthetic         from "@/views/lance/LanceProsthetic.vue";  
  import LanceKit           from "@/views/lance/LanceKit.vue";  
  import AppFooter        from "@/views/lance/AppFooter.vue";    
  import TutorialVideos     from "@/views/lance/TutorialVideos.vue";    
  import Mcenters           from "@/views/lance/Mcenters.vue";    
  import Msoft              from "@/views/lance/Msoft.vue";    
  
  import { mapActions, mapState } from "vuex";
  
  export default 
  {
    data(){
      return{
        site_data:null,
        isMenuOpen:false,
        isLangOpen:false,
        visibleSection:0
      }
    },
    components:
    {
      surgicalkits,
      DigitalRestoration,
      DigitalItems,
      LangMenu,
      SiteMenu,
      HomeHero,
      HomeHeroText,
      HomeBenefits,
      Workflow,
      ImplantRange,
      DrillingProtocols,
      TechInfo,
      InsertionOptions,
      Packaging,
      Coverscrews,
      Prosthetic,
      LanceKit,
      AppFooter,
      TutorialVideos,Mcenters,Msoft          
    }, 
    computed: {
      ...mapState(["siteData","siteDataReady","siteReady","siteVisibleSection"]),
  },
  mounted()
  {
    var vm=this;
    setTimeout(() => {
      vm.addDocumentEvents();
    }, 1000);    
    this.initScrollListener();
    this.checkSectionsView(); 

    this.loadMapData(); //*** specific for mguide mcenters map data
  },
  created: function () {      
      var vm = this;      
      this.loadData();      
      this.preloadFonts();
    },
    destroyed() {
        window.removeEventListener("scroll", this.scrollHandler);
    },
    methods: {
      ...mapActions(["xSetPlatform","loadSiteData","loadMapData","setSiteReady","setVisibleSection"]),
      addDocumentEvents()
      {
          //forct redirect to https
          if(window.location.protocol!= 'https:' && 
              window.location.hostname!='localhost'){
              window.location.protocol="https";
            }

          //check if user clicked out side of the languages menu or outside of the language top toggler
          var vm = this;
          var langtoggle1 = document.getElementById("langtoggle1");
          var langmenuObj = document.getElementById("langmenu1");          
          document.addEventListener('click', function(event) {
            const outsideClick = !langtoggle1.contains(event.target) && !langmenuObj.contains(event.target);
            if(outsideClick){
                vm.isLangOpen=false;//close langaue menu
            }
          });
      },
      preloadFonts()
      {
        var vm = this;
        if (document && document.fonts) {  
          //CSS Font Loading API
          //https://developer.mozilla.org/en-US/docs/Web/API/CSS_Font_Loading_API          
          const font1 = new FontFace("Inter", "url(https://fonts.googleapis.com/css?family=Inter:200,300,400,500&display=swap&subset=latin-ext)");
          document.fonts.add(font1);
          font1.load();
          document.fonts.ready.then(() => {
            setTimeout(() => {vm.setSiteReady(true);}, 300);
          });
      } else {
          vm.setSiteReady(true);// Fallback if API does not exist 
      }
    },      
    navToStart()
    {
        document.getElementsByClassName("siteSection")[0].scrollIntoView({ 
          behavior: 'smooth' 
        });
    },
    initScrollListener() 
    {
      //var scrollContainer = window;//
      setTimeout(() => 
      {
        var scrollContainer = document.getElementById("mainScroller");
        //window.addEventListener("scroll", this.scrollHandler, false);      
        scrollContainer.addEventListener("scroll", this.scrollHandler, false);
      }, 1000);
    },    
    scrollHandler() {
      this.checkSectionsView();
    },
    checkSectionsView()
    {      
      var vm=this;
      var reveals = document.querySelectorAll(".siteSection");
      //console.log("check scrolling... reveals.length="+reveals.length);
      for (var i = 0; i < reveals.length; i++) 
      {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 350;
        if (elementTop < windowHeight - elementVisible && elementTop>0) 
        {
          if(vm.visibleSection != i)
          {
            vm.visibleSection = i;
            vm.onSectionVisivle(i);
            //console.log("++ visibleSection="+vm.visibleSection);
          }
        }
      }
    },
    onSectionVisivle(domSectionIndex)
    {
        var vm=this;
        let sectionIndex = domSectionIndex;
        var sectionElement = document.querySelectorAll(".siteSection")[domSectionIndex];

        let sectionDataIndex = sectionIndex;
        if(sectionIndex>0){
          sectionDataIndex--;//!important because the dom 1st section is empty section
        }

        var secData =  this.siteData.SECTIONS[sectionDataIndex];
        var vid = document.getElementById("videoBgHero");
        this.setVisibleSection(sectionIndex);//change the store value
        if(domSectionIndex>2){          
          vid.pause();//pause video when hero is hidden
        }else{
          vid.play();//resume video when hero is visible
        }

        //////////////// SPECIFIC SITE CODE ////////////////////
        if(domSectionIndex>2){          
          setTimeout(() => {
            vm.xSetPlatform(1);  
          }, 1800);
        }
        if(secData.section=='benefits')
        {
          //the scroller on benefits is hidden becuase it's stopping the site from scrolling the hero to the benefits
          //when revealing the 'benefits' section set timeout for 1 sec and show the benfits scroller
          //imgBnScroller1 add 'show' class after 1 sec
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("show");//(display block)           
          }, 1100);
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("showOpaq"); //remove opacity            
          }, 1300);
        }        
        if(secData.section == 'surgical_kit')
        {
          var kitVideo = document.getElementById("kitVideo");
          kitVideo.play();//start kit video 
        }
      //////////////// SPECIFIC SITE CODE END ////////////////////

        this.revealSectionChildrenElements(sectionElement);
    },

    // REAVEL CHILD ELEMENTS 
    revealSectionChildrenElements(parentElement) 
    {
      var vm=this;
      parentElement.classList.add("active");
      var reveals = parentElement.querySelectorAll(".reveal");
      for (var i = 0; i < reveals.length; i++){
          if(reveals[i].classList.contains("active")==false)
          {
            vm.onRevealingSection(reveals[i].id);
            reveals[i].classList.add("active");
          }
      }
    },
    onRevealingSection(sectionID)
    {
        //add here specific site logic ...
        //if(sectionID=='hpSpeakers' || 
    },      
    toggleLangMenu()
    {
      if(this.isLangOpen){
        this.isLangOpen = false;//close it
      }else{
        this.isLangOpen = true;//open lang
        this.isMenuOpen=false;//close main menu
      }
    },
    openMenu()
    {
      this.isMenuOpen=true;
      this.isLangOpen=false;
    },
    getLangByRoute()
    {
      let lc = this.$route.params.lang;
      if(lc == undefined){lc="en";}
      return lc;
    },
    loadData: function () 
    {
      let lc = this.getLangByRoute();                
      this.loadSiteData(lc);        
    }
    },
    watch: 
    { 
     '$route.params.lang': {        
        handler: function(lang) {
          this.loadData();
        },
        deep: true,immediate: false
      }
    }   
  }
</script>
